class RetailStoreLocator {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.citySelect = container.querySelector('[data-rsl-city-select]');
    this.storeItems = container.querySelectorAll('[data-rsl-item]');
    this.emptyState = container.querySelector('[data-rsl-empty-state]');
    this.noResults = container.querySelector('[data-rsl-no-results]');
    this.countEl = container.querySelector('[data-rsl-count]');
    this.countNumber = container.querySelector('[data-rsl-count-number]');

    if (this.citySelect) {
      this.init();
    }
  }

  init() {
    this.citySelect.addEventListener('change', this.handleCityChange.bind(this));

    if (this.citySelect.value) {
      this.filterStores(this.citySelect.value);
    }
  }

  handleCityChange(event) {
    this.filterStores(event.target.value);
  }

  filterStores(selectedCity) {
    let visibleCount = 0;

    if (!selectedCity) {
      this.resetToEmptyState();
      return;
    }

    this.hideEmptyState();

    this.storeItems.forEach((item) => {
      const itemCity = item.dataset.city;
      const isMatch = itemCity === selectedCity;

      item.classList.toggle('is-visible', isMatch);

      if (isMatch) {
        visibleCount++;
      }
    });

    this.updateNoResultsState(visibleCount === 0);
    this.updateCount(visibleCount);
  }

  resetToEmptyState() {
    this.storeItems.forEach((item) => {
      item.classList.remove('is-visible');
    });

    if (this.emptyState) {
      this.emptyState.style.display = '';
    }

    if (this.noResults) {
      this.noResults.classList.remove('is-visible');
    }

    if (this.countEl) {
      this.countEl.style.display = 'none';
    }
  }

  hideEmptyState() {
    if (this.emptyState) {
      this.emptyState.style.display = 'none';
    }
  }

  updateNoResultsState(show) {
    if (this.noResults) {
      this.noResults.classList.toggle('is-visible', show);
    }
  }

  updateCount(count) {
    if (!this.countEl || !this.countNumber) return;

    if (count > 0) {
      this.countNumber.textContent = count;
      this.countEl.style.display = '';
    } else {
      this.countEl.style.display = 'none';
    }
  }
}

const RetailStoreLocatorManager = {
  instances: new Map(),

  init() {
    document.querySelectorAll('[data-section-type="retail-store-locator"]').forEach((container) => {
      this.createInstance(container);
    });

    this.bindEvents();
  },

  createInstance(container) {
    const sectionId = container.dataset.sectionId;

    if (!this.instances.has(sectionId)) {
      this.instances.set(sectionId, new RetailStoreLocator(container));
    }

    return this.instances.get(sectionId);
  },

  destroyInstance(sectionId) {
    if (this.instances.has(sectionId)) {
      this.instances.delete(sectionId);
    }
  },

  bindEvents() {
    document.addEventListener('shopify:section:load', (event) => {
      const container = event.target.querySelector('[data-section-type="retail-store-locator"]');

      if (container) {
        this.createInstance(container);
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      this.destroyInstance(event.detail.sectionId);
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => RetailStoreLocatorManager.init());
} else {
  RetailStoreLocatorManager.init();
}
